import type { Comic } from "@/types/comic";

export const comics: Comic[] = [
  {
    id: "heart-signal",
    title: "心动信号",
    subTitle: "심장 신호",
    author: "尹智雅",
    cover:
      "https://readdy.ai/api/search-image?query=Korean%20webtoon%20manhwa%20comic%20cover%20illustration%20of%20a%20romantic%20young%20couple%20under%20soft%20pink%20light%20with%20floating%20hearts%2C%20flat%20stylized%20digital%20art%2C%20clean%20minimal%20composition%2C%20simple%20pastel%20gradient%20background%2C%20high%20detail%2C%20cohesive%20modern%20manhwa%20aesthetic&width=600&height=800&seq=cover-01&orientation=portrait",
    description:
      "一次雨天共伞的偶遇，让两个原本毫无交集的人开始频繁出现在彼此的生活里。当心动变成信号，谁能先鼓起勇气说出那句喜欢？",
    category: "romance",
    tags: ["甜宠", "都市恋爱", "双向奔赴", "治愈"],
    status: "连载",
    updatedAt: "2026-10-10",
    views: 1520000,
    rating: 9.6,
    episodes: 42,
    schedule: "每周三、六更新",
    featured: true,
    isNew: false,
  },
  {
    id: "contract-lover",
    title: "契约恋人",
    subTitle: "계약 연인",
    author: "朴瑞妍",
    cover:
      "https://readdy.ai/api/search-image?query=Korean%20webtoon%20manhwa%20comic%20cover%20illustration%20of%20an%20elegant%20young%20man%20and%20woman%20in%20formal%20attire%20holding%20a%20contract%20with%20warm%20golden%20light%2C%20flat%20stylized%20digital%20art%2C%20clean%20minimal%20composition%2C%20simple%20soft%20gradient%20background%2C%20high%20detail%2C%20cohesive%20modern%20manhwa%20aesthetic&width=600&height=800&seq=cover-02&orientation=portrait",
    description:
      "为了应付家族安排的相亲，女总裁与落魄千金签下了一纸三个月的恋爱契约。假戏真做的边界，究竟由谁来守护？",
    category: "romance",
    tags: ["契约恋爱", "先婚后爱", "霸道总裁", "高甜"],
    status: "连载",
    updatedAt: "2026-10-09",
    views: 1280000,
    rating: 9.3,
    episodes: 30,
    schedule: "每周二、五更新",
    featured: true,
    isNew: false,
  },
  {
    id: "starry-magic-academy",
    title: "星夜魔法学院",
    subTitle: "별밤 마법학원",
    author: "崔敏浩",
    cover:
      "https://readdy.ai/api/search-image?query=Korean%20webtoon%20manhwa%20comic%20cover%20illustration%20of%20young%20mage%20students%20with%20glowing%20magic%20runes%20under%20a%20starry%20night%20sky%2C%20flat%20stylized%20digital%20art%2C%20clean%20minimal%20composition%2C%20simple%20deep%20gradient%20background%2C%20high%20detail%2C%20cohesive%20modern%20manhwa%20aesthetic&width=600&height=800&seq=cover-03&orientation=portrait",
    description:
      "当平凡少女误入只招收天才的星夜魔法学院，她隐藏的禁忌魔力成了所有人争夺的目标。魔法的代价，是记忆还是生命？",
    category: "fantasy",
    tags: ["魔法学院", "异世界", "成长", "热血"],
    status: "连载",
    updatedAt: "2026-10-11",
    views: 1340000,
    rating: 9.4,
    episodes: 38,
    schedule: "每周日更新",
    featured: true,
    isNew: false,
  },
  {
    id: "dragon-knight",
    title: "龙纹圣骑士",
    subTitle: "용문 성기사",
    author: "姜志勋",
    cover:
      "https://readdy.ai/api/search-image?query=Korean%20webtoon%20manhwa%20comic%20cover%20illustration%20of%20an%20armored%20knight%20with%20a%20glowing%20dragon%20emblem%20crest%20and%20a%20greatsword%2C%20flat%20stylized%20digital%20art%2C%20clean%20minimal%20composition%2C%20simple%20dark%20gradient%20background%2C%20high%20detail%2C%20cohesive%20modern%20manhwa%20aesthetic&width=600&height=800&seq=cover-04&orientation=portrait",
    description:
      "最后一位龙纹继承者背负着守护王国的使命，却在骑士团中遭到所有人的排挤。当巨龙再度苏醒，救赎与毁灭只在一念之间。",
    category: "fantasy",
    tags: ["史诗奇幻", "骑士", "巨龙", "完结佳作"],
    status: "完结",
    updatedAt: "2026-08-28",
    views: 980000,
    rating: 9.1,
    episodes: 60,
    schedule: "已完结",
    featured: false,
    isNew: false,
  },
  {
    id: "seventh-witness",
    title: "第七位证人",
    subTitle: "일곱 번째 증인",
    author: "韩东旭",
    cover:
      "https://readdy.ai/api/search-image?query=Korean%20webtoon%20manhwa%20comic%20cover%20illustration%20of%20a%20mysterious%20silhouette%20figure%20in%20a%20dark%20rainy%20alley%20with%20a%20single%20spotlight%2C%20flat%20stylized%20digital%20art%2C%20clean%20minimal%20composition%2C%20simple%20moody%20gradient%20background%2C%20high%20detail%2C%20cohesive%20modern%20manhwa%20aesthetic&width=600&height=800&seq=cover-05&orientation=portrait",
    description:
      "一桩尘封十年的悬案，六名证人相继意外身亡，而第七位证人始终没有现身。刑警重启调查，却发现真相与自己有关。",
    category: "suspense",
    tags: ["悬疑推理", "犯罪", "反转", "烧脑"],
    status: "连载",
    updatedAt: "2026-10-08",
    views: 1120000,
    rating: 9.5,
    episodes: 26,
    schedule: "每周四更新",
    featured: true,
    isNew: false,
  },
  {
    id: "midnight-call",
    title: "深夜来电",
    subTitle: "심야 전화",
    author: "孙宥真",
    cover:
      "https://readdy.ai/api/search-image?query=Korean%20webtoon%20manhwa%20comic%20cover%20illustration%20of%20a%20phone%20glowing%20in%20the%20dark%20with%20an%20eerie%20shadowy%20figure%20behind%2C%20flat%20stylized%20digital%20art%2C%20clean%20minimal%20composition%2C%20simple%20cold%20gradient%20background%2C%20high%20detail%2C%20cohesive%20modern%20manhwa%20aesthetic&width=600&height=800&seq=cover-06&orientation=portrait",
    description:
      "每到午夜零点，她都会接到一通来自「未来」的电话。电话那头的人，似乎正在一步步把她推向死亡的深渊。",
    category: "suspense",
    tags: ["恐怖", "惊悚", "灵异", "高能"],
    status: "连载",
    updatedAt: "2026-10-07",
    views: 860000,
    rating: 9.0,
    episodes: 22,
    schedule: "每周一更新",
    featured: false,
    isNew: true,
  },
  {
    id: "confession-under-blossom",
    title: "樱花树下的告白",
    subTitle: "벚꽃 아래 고백",
    author: "林夏恩",
    cover:
      "https://readdy.ai/api/search-image?query=Korean%20webtoon%20manhwa%20comic%20cover%20illustration%20of%20two%20high%20school%20students%20under%20a%20blooming%20cherry%20blossom%20tree%20in%20spring%2C%20flat%20stylized%20digital%20art%2C%20clean%20minimal%20composition%2C%20simple%20pastel%20pink%20gradient%20background%2C%20high%20detail%2C%20cohesive%20modern%20manhwa%20aesthetic&width=600&height=800&seq=cover-07&orientation=portrait",
    description:
      "转学第一天，她在樱花树下撞见了那个总是独来独往的少年。青春最美好的样子，大概就是那句没说出口的喜欢。",
    category: "school",
    tags: ["校园青春", "初恋", "青涩", "治愈"],
    status: "连载",
    updatedAt: "2026-10-11",
    views: 1050000,
    rating: 9.2,
    episodes: 34,
    schedule: "每周三更新",
    featured: false,
    isNew: false,
  },
  {
    id: "bad-senior-secret",
    title: "不良学长的秘密",
    subTitle: "불량 선배의 비밀",
    author: "郑恩菲",
    cover:
      "https://readdy.ai/api/search-image?query=Korean%20webtoon%20manhwa%20comic%20cover%20illustration%20of%20a%20cool%20high%20school%20senior%20with%20a%20soft%20hidden%20smile%20in%20school%20uniform%2C%20flat%20stylized%20digital%20art%2C%20clean%20minimal%20composition%2C%20simple%20soft%20gradient%20background%2C%20high%20detail%2C%20cohesive%20modern%20manhwa%20aesthetic&width=600&height=800&seq=cover-08&orientation=portrait",
    description:
      "全校都怕的那个不良学长，却在她面前露出了从未有过的温柔。他藏着秘密，而她，恰好是唯一知道真相的人。",
    category: "school",
    tags: ["校园", "反差萌", "暗恋", "高甜"],
    status: "连载",
    updatedAt: "2026-10-06",
    views: 920000,
    rating: 9.0,
    episodes: 28,
    schedule: "每周五更新",
    featured: false,
    isNew: true,
  },
  {
    id: "path-of-fist",
    title: "拳皇之路",
    subTitle: "격투의 길",
    author: "李宰勋",
    cover:
      "https://readdy.ai/api/search-image?query=Korean%20webtoon%20manhwa%20comic%20cover%20illustration%20of%20a%20determined%20young%20fighter%20with%20bandaged%20fists%20and%20dynamic%20energy%20aura%2C%20flat%20stylized%20digital%20art%2C%20clean%20minimal%20composition%2C%20simple%20bold%20gradient%20background%2C%20high%20detail%2C%20cohesive%20modern%20manhwa%20aesthetic&width=600&height=800&seq=cover-09&orientation=portrait",
    description:
      "从一个默默无闻的地下拳手，到站在世界擂台之巅的王者。拳头打出的不是胜利，而是不被击倒的信念。",
    category: "action",
    tags: ["热血格斗", "成长", "励志", "燃"],
    status: "连载",
    updatedAt: "2026-10-10",
    views: 1180000,
    rating: 9.3,
    episodes: 48,
    schedule: "每周二、六更新",
    featured: false,
    isNew: false,
  },
  {
    id: "seoul-love-guide",
    title: "首尔恋爱图鉴",
    subTitle: "서울 연애 도감",
    author: "金秀雅",
    cover:
      "https://readdy.ai/api/search-image?query=Korean%20webtoon%20manhwa%20comic%20cover%20illustration%20of%20a%20stylish%20young%20couple%20walking%20through%20a%20modern%20Seoul%20city%20street%20at%20dusk%2C%20flat%20stylized%20digital%20art%2C%20clean%20minimal%20composition%2C%20simple%20warm%20gradient%20background%2C%20high%20detail%2C%20cohesive%20modern%20manhwa%20aesthetic&width=600&height=800&seq=cover-10&orientation=portrait",
    description:
      "三对生活在首尔的年轻人，三种截然不同的恋爱方式。职场、租房、相亲…成年人的爱情，从来都不只是爱情。",
    category: "city",
    tags: ["都市情感", "群像", "现实", "治愈"],
    status: "连载",
    updatedAt: "2026-10-09",
    views: 760000,
    rating: 8.9,
    episodes: 24,
    schedule: "每周日更新",
    featured: false,
    isNew: true,
  },
  {
    id: "changan-moonlit-night",
    title: "长安花月夜",
    subTitle: "장안 화월야",
    author: "苏婉清",
    cover:
      "https://readdy.ai/api/search-image?query=Korean%20webtoon%20manhwa%20comic%20cover%20illustration%20of%20an%20elegant%20ancient%20Chinese%20lady%20in%20flowing%20hanfu%20under%20a%20full%20moon%2C%20flat%20stylized%20digital%20art%2C%20clean%20minimal%20composition%2C%20simple%20deep%20gradient%20background%2C%20high%20detail%2C%20cohesive%20modern%20manhwa%20aesthetic&width=600&height=800&seq=cover-11&orientation=portrait",
    description:
      "长安城的第一才女，却被迫卷入宫廷权谋。她以一己之力周旋于朝堂之上，只为守住心中那份未曾说出口的深情。",
    category: "historical",
    tags: ["古风", "宫廷", "权谋", "虐恋"],
    status: "完结",
    updatedAt: "2026-07-20",
    views: 890000,
    rating: 9.2,
    episodes: 52,
    schedule: "已完结",
    featured: false,
    isNew: false,
  },
  {
    id: "cat-cafe-diary",
    title: "猫咪咖啡馆日记",
    subTitle: "고양이 카페 일기",
    author: "文智恩",
    cover:
      "https://readdy.ai/api/search-image?query=Korean%20webtoon%20manhwa%20comic%20cover%20illustration%20of%20a%20cozy%20cat%20cafe%20with%20fluffy%20cats%20and%20warm%20afternoon%20sunlight%2C%20flat%20stylized%20digital%20art%2C%20clean%20minimal%20composition%2C%20simple%20warm%20gradient%20background%2C%20high%20detail%2C%20cohesive%20modern%20manhwa%20aesthetic&width=600&height=800&seq=cover-12&orientation=portrait",
    description:
      "失业的社恐青年接手了一家濒临倒闭的猫咪咖啡馆，在十三只猫和一个神秘店员的陪伴下，重新找回了生活的温柔。",
    category: "healing",
    tags: ["治愈日常", "猫咪", "温馨", "慢生活"],
    status: "连载",
    updatedAt: "2026-10-12",
    views: 680000,
    rating: 9.4,
    episodes: 20,
    schedule: "每周一、四更新",
    featured: false,
    isNew: true,
  },
];